var _path, _rect, _path2, _path3, _path4, _rect2, _path5, _path6, _path7, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToastLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 246,
    height: 166,
    fill: "none",
    viewBox: "0 0 246 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CAF2ED",
    d: "M242.989 94.472c7.754 28.183-5.289 64.811-29.446 70.481-24.017 5.559-59.399-19.868-92.833-27.497-33.434-7.629-65.198 2.763-88.164-8.006C9.579 118.682-4.811 86.474 2.847 61.898c7.659-24.576 37.533-41.882 62.66-51.745 25.378-9.835 46.148-12.339 64.17-8.317 18.133 4.162 33.13 14.932 54.987 30.005 21.856 15.073 50.433 34.56 58.325 62.631z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 155.761,
    height: 104.678,
    x: 42,
    y: 11,
    fill: "#F8F8F8",
    rx: 4.187
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4C00",
    d: "M42 15.187A4.187 4.187 0 0146.187 11h70.344v104.678H46.187A4.187 4.187 0 0142 111.491V15.187z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M52.049 93.905H102.294V98.93H52.049z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M52.049 100.604H84.709V103.116H52.049z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 57.147,
    height: 55.877,
    x: 128.37,
    y: 36.237,
    fill: "#fff",
    stroke: "#E8E8E8",
    strokeWidth: 1.905,
    rx: 4.762
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M134.401 54.969H179.484V63.859H134.401z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M146.467 80.368H167.42100000000002V83.54299999999999H146.467z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4C00",
    d: "M134.401 68.304H179.484V77.194H134.401z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF4C00",
    clipPath: "url(#clip0_133_28639)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M153.79 48.976c-.616 0-.95-.32-.95-.915v-1.746h-.215a.389.389 0 01-.381-.395.383.383 0 01.381-.374h.215v-.52a.444.444 0 01.887 0v.52h.346a.379.379 0 01.262.116.393.393 0 01.11.268.393.393 0 01-.11.269.379.379 0 01-.262.116h-.346v1.51c0 .264.167.367.305.367h.077c.249 0 .389.166.389.382s-.132.402-.708.402z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.564 48.976c-1.102 0-1.768-.804-1.768-1.76 0-.95.667-1.753 1.768-1.753 1.109 0 1.775.804 1.775 1.752a1.71 1.71 0 01-1.091 1.655 1.654 1.654 0 01-.684.106zm0-2.73c-.549 0-.853.45-.853.97s.305.978.853.978c.547 0 .859-.45.859-.979 0-.52-.312-.97-.859-.97zm4.887 2.688h-.07c-.069 0-.381-.055-.381-.388-.229.27-.623.43-1.06.43-.534 0-1.165-.36-1.165-1.11 0-.782.631-1.08 1.165-1.08.445 0 .839.145 1.06.408v-.451c0-.34-.292-.562-.735-.562a1.32 1.32 0 00-.749.215.328.328 0 01-.159.05.339.339 0 01-.286-.513c.208-.333.957-.472 1.344-.472.763 0 1.463.306 1.463 1.268v1.768a.433.433 0 01-.43.436l.003.001zM161 47.673c-.146-.194-.423-.292-.707-.292-.347 0-.631.179-.631.507 0 .311.284.492.631.492.284 0 .561-.097.707-.291v-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M163.961 48.976c-.436 0-1.136-.146-1.344-.445a.302.302 0 01-.062-.187.384.384 0 01.111-.259.366.366 0 01.256-.108c.064 0 .126.018.181.052.263.152.61.27.9.27.382 0 .562-.152.562-.36 0-.555-1.99-.105-1.99-1.422 0-.562.493-1.053 1.373-1.053.436 0 1.032.14 1.22.409a.29.29 0 01.056.17.345.345 0 01-.346.333.353.353 0 01-.167-.041 1.534 1.534 0 00-.757-.201c-.319 0-.526.146-.526.333 0 .499 1.982.083 1.982 1.433 0 .611-.52 1.076-1.449 1.076zm3.223 0c-.616 0-.95-.32-.95-.915v-1.746h-.215a.389.389 0 01-.381-.395.383.383 0 01.381-.374h.215v-.52a.455.455 0 01.144-.293.444.444 0 01.743.293v.52h.347a.389.389 0 01.372.385.388.388 0 01-.372.384h-.347v1.51c0 .264.167.367.305.367h.077c.249 0 .388.166.388.382s-.13.402-.707.402z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.679 47.6a9.78 9.78 0 00-.048-1.11c-.027-.25-.11-.568-.376-.634a.183.183 0 00.104-.003c.308-.164.284-.567.175-.858-.143-.382-.483-.654-.82-.834a4.127 4.127 0 00-3.999.145c-.305.191-.656.564-.501.98a.843.843 0 00.181.276l.117.124a2.034 2.034 0 00-.346.674c-.223.792-.186 1.3-.125 1.937.038.393.165.978.611 1.044.364.051.758-.07 1.121-.115.4-.047.804-.123 1.209-.111.571.015 1.137.151 1.709.158.301.002.803.032.893-.372.085-.385.089-.784.089-1.176.005-.042.005-.084.005-.125h.001zm-.652.664c-.142.325-.544.289-.824.265l-1.254-.152c-.373-.011-.743.06-1.106.142-.272.06-.651.22-.897.007-.273-.235-.321-.635-.325-.973a5.78 5.78 0 01.089-.91c.034-.186.088-.367.16-.54.097-.252.242-.404.249-.396-.073-.077-.16-.118-.21-.223-.186-.395.28-.73.534-.845.891-.405 2.136-.364 2.977.154.262.163.771.72.295.997.293.14.369.565.401.867.051.484.036.973-.045 1.454a.674.674 0 01-.044.153z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_28639"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H22.224V5.983H0z",
    transform: "translate(145.831 43.54)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastLogin);
export default __webpack_public_path__ + "static/media/toast-login.a2a178bb0fc4d34f7f02028700ea9b9a.svg";
export { ForwardRef as ReactComponent };